<template>
  <div>
    <div class="menu-title">语音试听管理</div>
    <div class="menu-content voice-preview-manage">
      <el-form :inline="true" :model="query" size="small" class="voice-search">
        <el-form-item label="模型平台">
          <el-input v-model="query.EQS_modelPlatform" clearable placeholder="输入模型平台" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="模型">
          <el-input v-model="query.EQS_model" clearable placeholder="输入模型" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="语音名称">
          <el-input v-model="query.LIKES_voiceName" clearable placeholder="输入语音名称" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>

      <div class="voice-actions">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreate">添加语音</el-button>
      </div>

      <div class="table-list">
        <el-table v-loading="loading" :data="result.records" style="width: 100%">
          <el-table-column type="index" label="序号" width="65" />
          <el-table-column prop="modelPlatform" label="模型平台" min-width="120" show-overflow-tooltip />
          <el-table-column prop="model" label="模型" min-width="150" show-overflow-tooltip />
          <el-table-column prop="voiceName" label="语音名称" min-width="140" show-overflow-tooltip />
          <el-table-column prop="voiceId" label="语音 ID" min-width="160" show-overflow-tooltip />
          <el-table-column prop="audioUrl" label="音频地址" min-width="210" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" width="165" />
          <el-table-column label="操作" width="280" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" :icon="playingKey === String(scope.row.id) ? 'el-icon-video-pause' : 'el-icon-video-play'"
                         :title="playingKey === String(scope.row.id) ? '停止试听' : '试听'"
                         :aria-label="playingKey === String(scope.row.id) ? '停止试听' : '试听'"
                         :disabled="!scope.row.audioUrl" @click="togglePlay(scope.row.audioUrl, String(scope.row.id))">
                {{ playingKey === String(scope.row.id) ? '停止' : '试听' }}
              </el-button>
              <el-button type="text" size="small" icon="el-icon-download" title="下载音频" aria-label="下载音频"
                         :loading="downloadingId === scope.row.id" :disabled="!scope.row.audioUrl"
                         @click="downloadRow(scope.row)">下载</el-button>
              <el-button type="text" size="small" icon="el-icon-edit" title="编辑" aria-label="编辑" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" icon="el-icon-delete" title="删除" aria-label="删除" @click="removeRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination background :current-page="query.pageNo" :page-size="query.pageSize"
                       :page-sizes="[10, 20, 30, 40, 50]" :total="result.total"
                       layout="total, sizes, prev, pager, next"
                       @current-change="changePage" @size-change="changeSize" />
      </div>

      <audio ref="player" preload="none" style="display: none" @ended="stopPlayback" @error="onAudioError" />
    </div>

    <el-dialog :title="form.id == null ? '添加语音' : '编辑语音'" :visible.sync="dialogVisible"
               :close-on-click-modal="false" width="620px" custom-class="voice-preview-dialog"
               @closed="onDialogClosed">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="模型平台" prop="modelPlatform">
          <el-input v-model="form.modelPlatform" placeholder="输入模型平台" />
        </el-form-item>
        <el-form-item label="模型" prop="model">
          <el-input v-model="form.model" placeholder="输入模型" />
        </el-form-item>
        <el-form-item label="语音名称" prop="voiceName">
          <el-input v-model="form.voiceName" placeholder="输入语音名称" />
        </el-form-item>
        <el-form-item label="语音 ID" prop="voiceId">
          <el-input v-model="form.voiceId" placeholder="输入语音 ID" />
        </el-form-item>
        <el-form-item label="音频地址" prop="audioUrl">
          <el-input v-model="form.audioUrl" placeholder="输入音频地址或上传音频" />
          <div class="voice-upload-actions">
            <el-upload action="#" :auto-upload="false" :show-file-list="false"
                       :disabled="uploading" :on-change="uploadAudio">
              <el-button size="small" icon="el-icon-upload2" :loading="uploading">上传音频</el-button>
            </el-upload>
            <el-button type="text" :icon="playingKey === 'form' ? 'el-icon-video-pause' : 'el-icon-video-play'"
                       :disabled="!form.audioUrl" @click="togglePlay(form.audioUrl, 'form')">
              {{ playingKey === 'form' ? '停止试听' : '试听' }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" :disabled="uploading" @click="save">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request, { getBaseUrl } from '@/utils/request';

const api = '/core/voice-preview';

function emptyForm() {
  return { id: null, modelPlatform: '', model: '', voiceName: '', voiceId: '', audioUrl: '' };
}

export default {
  name: 'VoicePreviewManage',
  data() {
    return {
      query: { pageNo: 1, pageSize: 10, EQS_modelPlatform: '', EQS_model: '', LIKES_voiceName: '', DESCI_createTime: 1 },
      result: { records: [], total: 0 },
      form: emptyForm(),
      rules: {
        modelPlatform: [{ required: true, whitespace: true, message: '请输入模型平台', trigger: 'blur' }],
        model: [{ required: true, whitespace: true, message: '请输入模型', trigger: 'blur' }],
        voiceName: [{ required: true, whitespace: true, message: '请输入语音名称', trigger: 'blur' }],
        voiceId: [{ required: true, whitespace: true, message: '请输入语音 ID', trigger: 'blur' }],
        audioUrl: [{ required: true, whitespace: true, message: '请输入或上传音频地址', trigger: 'blur' }]
      },
      dialogVisible: false,
      dialogVersion: 0,
      loading: false,
      saving: false,
      uploading: false,
      playingKey: null,
      downloadingId: null
    };
  },
  mounted() {
    this.load();
  },
  beforeDestroy() {
    this.stopPlayback();
    this.dialogVersion += 1;
  },
  methods: {
    load() {
      this.loading = true;
      return request({ url: `${api}/query_pages`, method: 'post', data: this.query })
        .then(result => {
          this.result = { records: result.records || [], total: result.total || 0 };
        })
        .finally(() => { this.loading = false; });
    },
    search() {
      this.query.pageNo = 1;
      this.stopPlayback();
      return this.load();
    },
    changePage(page) {
      this.query.pageNo = page;
      this.stopPlayback();
      return this.load();
    },
    changeSize(size) {
      this.query.pageSize = size;
      return this.changePage(1);
    },
    openCreate() {
      this.dialogVersion += 1;
      this.uploading = false;
      this.form = emptyForm();
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    openEdit(row) {
      this.dialogVersion += 1;
      this.uploading = false;
      this.form = {
        id: row.id,
        modelPlatform: row.modelPlatform || '',
        model: row.model || '',
        voiceName: row.voiceName || '',
        voiceId: row.voiceId || '',
        audioUrl: row.audioUrl || ''
      };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form.clearValidate());
    },
    onDialogClosed() {
      if (this.dialogVisible) return;
      this.dialogVersion += 1;
      this.uploading = false;
      if (this.playingKey === 'form') this.stopPlayback();
    },
    uploadAudio(file) {
      if (this.uploading || !file.raw) return;
      const version = this.dialogVersion;
      const data = new FormData();
      data.append('file', file.raw);
      this.uploading = true;
      return request({ url: '/upload/file/voice', method: 'post', data })
        .then(path => {
          if (version !== this.dialogVersion || !this.dialogVisible) return;
          if (!path) {
            this.$message.error('音频上传失败');
            return;
          }
          this.form.audioUrl = path;
          this.$refs.form.validateField('audioUrl');
          this.$message.success('上传成功');
        })
        .catch(() => {})
        .finally(() => { if (version === this.dialogVersion) this.uploading = false; });
    },
    save() {
      if (this.saving || this.uploading) return;
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const editing = this.form.id != null;
        const data = {
          ...(editing ? { id: this.form.id } : {}),
          modelPlatform: this.form.modelPlatform.trim(),
          model: this.form.model.trim(),
          voiceName: this.form.voiceName.trim(),
          voiceId: this.form.voiceId.trim(),
          audioUrl: this.form.audioUrl.trim()
        };
        this.saving = true;
        request({ url: `${api}/${editing ? 'modify' : 'create'}`, method: 'post', data })
          .then(() => {
            this.$message.success(editing ? '编辑成功' : '添加成功');
            this.dialogVisible = false;
            this.load();
          })
          .finally(() => { this.saving = false; });
      });
    },
    removeRow(row) {
      return this.$confirm('确定删除该语音吗？', '提示', { type: 'warning' })
        .then(() => request({ url: `${api}/remove/${row.id}`, method: 'post' }))
        .then(() => {
          if (this.playingKey === String(row.id)) this.stopPlayback();
          this.$message.success('删除成功');
          if (this.result.records.length === 1 && this.query.pageNo > 1) this.query.pageNo -= 1;
          this.load();
        })
        .catch(() => {});
    },
    audioSrc(value) {
      const path = String(value || '').trim();
      if (!path) return '';
      if (/^https?:\/\//i.test(path)) return path;
      const base = getBaseUrl().replace(/\/+$/, '');
      if (path.startsWith('/uploads/')) return `${base}${path}`;
      return `${base}/uploads/${path.replace(/^\/+/, '')}`;
    },
    togglePlay(value, key) {
      const src = this.audioSrc(value);
      if (!src) return;
      if (this.playingKey === key) {
        this.stopPlayback();
        return;
      }
      this.stopPlayback();
      const player = this.$refs.player;
      player.src = src;
      this.playingKey = key;
      const playback = player.play();
      if (playback && playback.catch) playback.catch(() => {
        if (this.playingKey === key) this.onAudioError();
      });
    },
    stopPlayback() {
      const player = this.$refs.player;
      this.playingKey = null;
      if (!player) return;
      player.pause();
      player.removeAttribute('src');
      player.load();
    },
    onAudioError() {
      if (this.playingKey == null) return;
      this.stopPlayback();
      this.$message.error('音频播放失败，请检查音频地址');
    },
    async downloadRow(row) {
      const src = this.audioSrc(row.audioUrl);
      if (!src || this.downloadingId != null) return;
      this.downloadingId = row.id;
      try {
        const response = await fetch(src);
        if (!response.ok) throw new Error('音频获取失败');
        const blob = await response.blob();
        const path = new URL(src).pathname;
        const extension = path.match(/\.([A-Za-z0-9]{1,16})$/);
        const name = String(row.voiceName || row.voiceId || '语音试听').replace(/[\\/:*?"<>|]/g, '_');
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = `${name}.${extension ? extension[1] : 'bin'}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      } catch (error) {
        this.$message.error('音频下载失败，请检查音频地址或资源服务的跨域配置');
      } finally {
        this.downloadingId = null;
      }
    }
  }
};
</script>

<style lang="scss">
.voice-preview-manage .voice-search .el-input { width: 180px; }
.voice-preview-manage .voice-actions { margin-bottom: 20px; }
.voice-preview-manage .el-table .el-button { margin-left: 0; margin-right: 10px; }
.voice-preview-dialog { max-width: calc(100vw - 32px); }
.voice-upload-actions { display: flex; align-items: center; gap: 14px; margin-top: 8px; }
@media (max-width: 700px) {
  .voice-preview-manage .voice-search .el-input { width: 100%; }
}
</style>
